<template>
  <page>
    <v-container fluid grid-list-md>
      <v-layout row wrap>
        <v-flex xs12>
          <v-expansion-panels v-model="panel1" multiple>
            <v-expansion-panel>
              <v-expansion-panel-header>
                <div><v-icon>mdi-filter-variant</v-icon> {{ labels.dateRangeTitle }}</div>
              </v-expansion-panel-header>
              <v-expansion-panel-content>
                <v-card>
                  <v-card-text>
                    <v-container fluid grid-list-sm>
                      <v-layout row wrap>
                        <v-flex xs12 sm6 md6 lg6>
                          <cal-picker
                            v-model="forms.tranDateFrom"
                            :label="labels.tranDateFrom"
                            :data-vv-as="labels.tranDateFrom"
                            data-vv-name="tranDateFrom"
                            :error-messages="errors.collect('tranDateFrom')"
                            v-validate="'required|checkSystemDate'"
                            ref="fromDate"
                            :max="new Date()"
                          ></cal-picker>
                        </v-flex>
                        <v-flex xs12 sm6 md6 lg6>
                          <cal-picker
                            v-model="forms.tranDateTo"
                            :label="labels.tranDateTo"
                            :data-vv-as="labels.tranDateTo"
                            data-vv-name="tranDateTo"
                            :error-messages="errors.collect('tranDateTo')"
                            :max="new Date()"
                            v-validate="'required|checkSystemDate|from_to_date:fromDate'"
                          ></cal-picker>
                        </v-flex>
                      </v-layout>
                    </v-container>
                  </v-card-text>
                </v-card>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
        </v-flex>
        <v-flex xs12>
          <v-expansion-panels v-model="panel2" multiple>
            <v-expansion-panel>
              <v-expansion-panel-header>
                <div><v-icon>mdi-filter-variant</v-icon> {{ labels.modules }}</div>
              </v-expansion-panel-header>
              <v-expansion-panel-content>
                <v-card>
                  <v-card-text>
                    <v-container fluid grid-list-sm>
                      <v-layout row wrap>
                        <v-flex xs12 sm3 md3 lg3>
                          <v-checkbox
                            color="primary"
                            v-model="forms.uw"
                            :label="labels.uw"
                            :error-messages="errors.collect('uw')"
                            data-vv-name="uw"
                            :data-vv-as="labels.uw"
                          ></v-checkbox>
                        </v-flex>
                        <v-flex xs12 sm3 md3 lg3>
                          <v-checkbox
                            color="primary"
                            v-model="forms.cl"
                            :label="labels.cl"
                            :error-messages="errors.collect('cl')"
                            data-vv-name="cl"
                            :data-vv-as="labels.cl"
                          ></v-checkbox>
                        </v-flex>
                        <v-flex xs12 sm3 md3 lg3>
                          <v-checkbox
                            color="primary"
                            v-model="forms.ac"
                            :label="labels.ac"
                            :error-messages="errors.collect('ac')"
                            data-vv-name="ac"
                            :data-vv-as="labels.ac"
                          ></v-checkbox>
                        </v-flex>
                        <v-flex xs12 sm3 md3 lg3>
                          <v-checkbox
                            color="primary"
                            v-model="forms.xm"
                            :label="labels.xm"
                            :error-messages="errors.collect('xm')"
                            data-vv-name="xm"
                            :data-vv-as="labels.xm"
                          ></v-checkbox>
                        </v-flex>
                      </v-layout>
                    </v-container>
                  </v-card-text>
                </v-card>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
        </v-flex>
        <v-flex xs12 sm12 md12 lg12>
          <v-checkbox
            v-model="forms.printRptRunTime"
            :label="labels.printRptRunTime"
            data-vv-name="printRptRunTime"
            :data-vv-as="labels.printRptRunTime"
          ></v-checkbox>
        </v-flex>
        <v-flex xs12 sm6 md6 lg6>
          <v-btn class="mr-3" color="primary" :loading="processing" @click.prevent="doSubmit">
            <v-icon left dark>mdi-file-export</v-icon>
            {{ labels.export }}
          </v-btn>
          <v-btn-toggle dense mandatory v-model="forms.format">
            <v-btn text v-for="format in supportedList" :key="format.value" :value="format.value">
              <span>{{ format.label }}</span>
              <v-icon :color="format.color">{{ format.icon }}</v-icon>
            </v-btn>
          </v-btn-toggle>
        </v-flex>
      </v-layout>
    </v-container>

    <v-dialog v-model="processing" persistent width="300">
      <v-card color="primary" dark>
        <v-card-text class="pa-3">
          Processing...
          <v-progress-linear indeterminate color="white" class="mb-0"></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-dialog v-model="showErrorDialog" width="800px">
      <v-card>
        <v-toolbar dense color="grey lighten-3" flat>
          <v-icon>mdi-information</v-icon>
          <v-toolbar-title>System Information</v-toolbar-title>
          <v-spacer></v-spacer>
        </v-toolbar>
        <v-card-text>
          <div v-if="messages.length > 0" class="pb-3">
            <v-subheader>Oops something went wrong:</v-subheader>
            <ul class="showErrorMsgs">
              <li v-for="(error, index) in messages" :key="index">
                {{ error.message }}
              </li>
            </ul>
          </div>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="red darken-1" text @click.native="showErrorDialog = false">Close</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </page>
</template>

<script>
import MessageMixin from '@/mixins/message'
import { reportFormat } from '@/const/report'
// import { extractMenu } from '@/utils/extract'

export default {
  data() {
    return {
      labels: {
        dateRangeTitle: 'Date Range',
        modules: 'Module',
        tranDateFrom: 'Transaction Date From*',
        tranDateTo: 'Transaction Date To*',
        uw: 'Underwriting',
        cl: 'Claims',
        ac: 'Accounts',
        xm: 'Parameters',
        export: 'Export To',
        printRptRunTime: 'Print Runtime Parameters'
      },
      forms: {
        tranDateFrom: null,
        tranDateTo: null,
        uw: false,
        cl: false,
        ac: false,
        xm: false,
        format: 'PDF',
        printRptRunTime: true
      },
      processing: false,
      showErrorDialog: false,
      supportedFormat: [],
      menu: {},
      panel1: [0],
      panel2: [0]
    }
  },
  watch: {
    supportedList: function (value) {
      if (value && value.length > 0) {
        // Default the 1st value
        this.forms.format = value[0].value
      }
    },
    displayErrorDialog: {
      handler: function (messages) {
        if (messages && messages.length > 0) {
          this.showErrorDialog = true
        }
      },
      deep: true
    }
  },
  computed: {
    displayErrorDialog() {
      return this.messages
    },
    supportedList() {
      const result = []
      if (this.supportedFormat && this.supportedFormat.length > 0) {
        this.supportedFormat.map((format) => {
          if (reportFormat[format]) {
            result.push(reportFormat[format])
          }
        })
      }
      return result
    }
  },
  methods: {
    async doInit() {
      this.forms.tranDateFrom = new Date()
      this.forms.tranDateTo = new Date()
      const apiUrl = this.$store.state.underwriting.dataTransferSettings.menu.initMasAML
      if (apiUrl) {
        try {
          const result = await this.$http.get(apiUrl)
          if (result.data) {
            const { data } = result.data
            if (data) {
              this.supportedFormat = data.format
              // this.menu = extractMenu(result.data._links)
            }
          }
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.message(data)
          }
          this.processing = false
        }
      } else {
        this.$toast.error('The request failed because it is trying to execute an invalid API url. [initMasAML]')
      }
    },
    modulesValidation() {
      if (this.forms.uw === false && this.forms.cl === false && this.forms.ac === false && this.forms.xm === false) {
        this.$toast.error('At least one module must be selected.')
      } else {
        this.processExport()
      }
    },
    doSubmit() {
      this.resetMessages()
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.modulesValidation()
        } else {
          this.promptFieldCheck()
        }
      })
    },
    async processExport() {
      const apiUrl = this.$store.state.underwriting.dataTransferSettings.menu.exportMasAML
      if (apiUrl) {
        try {
          this.processing = true
          await this.$http.post(apiUrl, this.forms)
          this.$toast.success('Submitted Successfully.')
          this.processing = false
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.message(data)
          }
          this.processing = false
        }
      } else {
        this.$toast.error('The request failed because it is trying to execute an invalid API url. [exportMasAML]')
      }
    }
  },
  created() {
    this.$validator.extend('valModules', {
      getMessage(field, args) {
        return 'At least one module must be selected.'
      },
      validate(value, args) {
        return false
      }
    })
  },
  beforeMount() {
    if (this.$store.state.underwriting.dataTransferSettings.init !== 1) {
      this.$store.dispatch('dataTransferInit').then(() => {
        this.doInit()
      })
    } else {
      this.doInit()
    }
  },
  mixins: [MessageMixin]
}
</script>

<style>
</style>
